// Recording indicator protocol (F-REC-1, §10.5) — a TRUST feature. The
// recorder broadcasts rec:on over the reliable data channel on start, on a
// 15s heartbeat, AND targeted to every new join; all clients render a
// persistent, non-dismissable red badge. rec:off or heartbeat loss clears it.
//
// This is separate from whether recording actually succeeds locally: the
// promise to attendees is "someone is capturing this," asserted continuously.

export const REC_TOPIC = 'bz.rec';

// Heartbeat cadence and the staleness window after which a silent recorder is
// assumed stopped (covers a crashed recorder that never sent rec:off).
export const REC_HEARTBEAT_MS = 15_000;
export const REC_STALE_MS = 40_000;

export interface RecWire {
  v: 1;
  on: boolean;
  by: string; // recorder's display name
}

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function encodeRec(on: boolean, by: string): Uint8Array<ArrayBuffer> {
  return new Uint8Array(encoder.encode(JSON.stringify({ v: 1, on, by } satisfies RecWire)));
}

export function decodeRec(payload: Uint8Array): RecWire | null {
  try {
    const w = JSON.parse(decoder.decode(payload)) as RecWire;
    return w.v === 1 && typeof w.on === 'boolean' ? w : null;
  } catch {
    return null;
  }
}
